import { useMutation, useQueryClient } from '@tanstack/react-query'
import { CreateRequestCommentInput } from '@omnea-app/comments/commentsFrontendClient'
import { CommentResponse, CommentsHttpClient } from '@omnea-app/comments/commentsHttpClient'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { throwIfApiError } from '@omnea-app/packages/universal/error-handling/throwifApiError'
import { requestCommentsQueryKey } from './useGetRequestComment'

type CommentResponseType = CommentResponse<'/request', 'post'>

export const useInsertRequestComment = ({ requestId, onError }: { requestId: string; onError?: () => void }) => {
  const { getToken } = useAuthenticatedUser()
  const queryClient = useQueryClient()
  return useMutation<
    CommentResponseType['data'],
    CommentResponseType['error'],
    Omit<CreateRequestCommentInput, 'postedBy' | 'id'>
  >({
    mutationFn: async (body) => {
      const apiClient = new CommentsHttpClient({ authorization: await getToken() })
      const { data, error } = await apiClient.POST('/request', {
        body,
      })
      throwIfApiError(error)
      return data
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [requestCommentsQueryKey, requestId] })
    },
    onError,
  })
}
